export default {
  tiposCardapios: [],
  paises: null,
  uvas: null
}